import { createSaveStateTracker } from '@/lib/save-state';

export const journalSaves = createSaveStateTracker('journal save');
